import { Layout as InternalLayout, Header } from "./Layout";

type InternalLayoutType = typeof InternalLayout;

interface LayoutType extends InternalLayoutType {
  Header: typeof Header;
}

const Layout = InternalLayout as LayoutType;

Layout.Header = Header;

export default Layout;
